// export const HOST = "https://devs.coincaex.com/helmut/coincaex";
// export const HOST = "https://qa.coincaex.com/";
// export const HOST = "http://localhost/coincaex";
// export const HOST = "https://uat.coincaex.com/";
export const HOST = window.location.origin || JSON.parse(localStorage.getItem("WEBAPP_CONFIG")).host

export const STATUS_CODE = Object.freeze({
    OK: 200,
    CREATED: 201,
    NO_CONTENT: 204,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    SERVER_ERROR: 500,
});
